import { Box, Slider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  FUEL_EIGHTHS_MAX,
  FUEL_EIGHTHS_MIN,
  fuelEighthsToPercent,
} from '@/hooks/useCourtesyVehicles';

interface FuelEighthsSliderProps {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export function FuelEighthsSlider({ value, onChange, disabled = false }: FuelEighthsSliderProps) {
  const { t } = useTranslation('workorders');
  const marks = Array.from({ length: FUEL_EIGHTHS_MAX + 1 }, (_, eighths) => ({
    value: eighths,
    label: t('courtesy.fuelPercent', { percent: fuelEighthsToPercent(eighths) }),
  }));

  return (
    <Box>
      <Typography id="courtesy-fuel-label" gutterBottom>
        {t('courtesy.fuel')}
      </Typography>
      <Slider
        aria-labelledby="courtesy-fuel-label"
        aria-label={t('courtesy.fuel')}
        min={FUEL_EIGHTHS_MIN}
        max={FUEL_EIGHTHS_MAX}
        step={1}
        marks={marks}
        value={value}
        onChange={(_, next) => {
          if (typeof next === 'number') onChange(next);
        }}
        disabled={disabled}
        valueLabelDisplay="auto"
        valueLabelFormat={(eighths) =>
          t('courtesy.fuelPercent', { percent: fuelEighthsToPercent(eighths) })
        }
      />
    </Box>
  );
}
